import { render } from "./Licenca.vue?vue&type=template&id=216c7ba5"
import script from "./Licenca.vue?vue&type=script&lang=ts"
export * from "./Licenca.vue?vue&type=script&lang=ts"
script.render = render

export default script